import autoshipLogic from './autoshipLogic';
import autoshipCreationLogic from './autoshipCreationLogic';

export default [...autoshipLogic, ...autoshipCreationLogic];
